// extracted by mini-css-extract-plugin
export default {"container":"K9Otj4LwDwpadmRvBp63","hoverableBadge":"RSjN5vPXnSMXM2weoQat"};